mutation CommunicationChannelCreate($input: CommunicationChannelCreateInput!) {
  communicationChannelCreate(input: $input) {
    communicationChannels {
      id
      name
      description
      isMessages
      isReports
      _rowTimestamp
      _isUpdatable
      _isDeletable
      _createdDate
      _isAlerts
    }
  }
}
